var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChainCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8325_1991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "url(#paint0_linear_8325_1991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7768 13.575L15.0143 9.3375C15.1143 9.2375 15.2331 9.1875 15.3706 9.1875C15.5081 9.1875 15.6268 9.2375 15.7268 9.3375C15.8268 9.4375 15.8768 9.55625 15.8768 9.69375C15.8768 9.83125 15.8268 9.95 15.7268 10.05L11.1268 14.65C11.0268 14.75 10.9101 14.8 10.7768 14.8C10.6435 14.8 10.5268 14.75 10.4268 14.65L8.27681 12.5C8.17681 12.4 8.1289 12.2812 8.13306 12.1437C8.13723 12.0063 8.18931 11.8875 8.28931 11.7875C8.38931 11.6875 8.50806 11.6375 8.64556 11.6375C8.78306 11.6375 8.90181 11.6875 9.00181 11.7875L10.7768 13.575Z",
    fill: "#F7F7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8325_1991",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E7D32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF598"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8325_1991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainCompleted);
export default __webpack_public_path__ + "static/media/chain_completed.fc80b9674782c298300ebf2a89be0bdd.svg";
export { ForwardRef as ReactComponent };